<template>
  <div class="feedcontent">
    <titlebar titleName="反馈建议" goback="true"></titlebar>
    <div class="content">
      <form>
        <div class="title">
          <p>问题和建议</p>
          <p>{{ message.length }}/200</p>
        </div>
        <van-field
          v-model="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="200"
          placeholder="请输入留言"
          class="lyk"
        />
        <div class="title">
          <p>图片</p>
          <p>0/4</p>
        </div>
        <div class="photo">
          <van-uploader
            v-model="fileList"
            :after-read="afterRead"
            :max-count="4"
            
          />
        </div>
        <div class="title">
          <p>联系方式</p>
        </div>
        <van-field
          style="width: 92vw; margin: 0 auto; borderradius: 3vw"
          v-model="value"
          placeholder="请输入手机号以便联系"
        />
        <div class="btn" @click="submit">提交</div>
      </form>
    </div>
  </div>
</template>

<script>
import apiFun from "../../servers/apiFun";
import comTool from "../../assets/js/until";
import titlebar from "../../components/index/titleBar.vue";
export default {
  data() {
    return {
      message: "",
      value: "",
      file: "",
      fileList: [],
    };
  },
  components: {
    titlebar,
  },
  methods: {
    submit() {
      if (!this.message.trim().length > 0) {
        this.$toast.fail("请输入你的问题或建议！");
        return;
      }
      var reg = new RegExp("^1[3-9][0-9]{9}$");
      if (!reg.test(this.value)) {
        this.$toast.fail("请输入正确的手机号码方便与你联系！");
        return;
      }
      let data = {
        gid: "100682",
        pid: "100",
        mid: "10000",
        p_mid: "1",
        device_id: "00e7efa241dae8842c8286cf69508e9c",
        client: "h5",
        client_id: "00e7efa241dae8842c8286cf69508e9c",
        tm: comTool.getTm(),
        content: this.message,
        mobile: this.value,
        imgs: this.file,
        uname: this.$cookies.get("uname"),
        access_token: this.$cookies.get("access_token"),
      };
      data.sign = comTool.querySort(data);
      apiFun.GameSuggest(data).then((res) => {
        if(res.code == 200){
            this.$toast.success("提交成功！");
            setInterval(()=>{
                this.$router.go(-1)
            },1500)
        }else{
            this.$toast.fail(res.msg);
        }
      });
    },
    afterRead(file) {
      let content = file.file;
      let data = new FormData();
      data.append("file[]", content);
      this.$axios
        .post(
          "https://boxapi.dingdangyou.cn/api/v1/box/game/suggest_upload",
          data
        )
        .then((res) => {
          if (this.file.length > 0) {
            this.file += `,${res.data.data[0].img_ur}`;
          } else {
            this.file = res.data.data[0].img_ur;
          }
          console.log(this.file);
        });
    },
  },
};
</script>

<style lang="less"  scoped>
.content {
  padding-top: 13vw;
  .title {
    width: 92vw;
    margin: 2vw auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #8f8f8f;
    font-size: 3vw;
  }
  .lyk {
    width: 92vw;
    margin: 0 auto;
  }
  .photo {
    background: #fff;
    width: 92vw;
    height: 60.2vw;
    margin: 0 auto;
    border-radius: 3vw;
    display: flex;
    align-items: flex-start;
    padding: 0 2vw;
    padding-top: 2vw;
    
  }
  .btn {
    width: 40.6667vw;
    height: 9.2vw;
    line-height: 9.2vw;
    background: #ffa623;
    font-size: 4vw;
    border-radius: 3vw;
    color: #fff;
    margin: 6vw auto;
  }
}
</style>